var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCarB(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 32,
    viewBox: "0 0 34 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.18954 11.928C6.2621 11.928 7.89851 16.426 9.34844 16.9976C10.7973 17.5691 14.5655 17.6836 16.9998 17.6836",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 10.9476C14.6519 10.9476 5.99533 11.4888 5.1832 11.9346",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.20724 21.6147C3.20724 21.6147 3.69607 22.5197 4.58656 23.1114C5.47704 23.7043 8.72449 23.8604 8.72449 23.8604L9.41414 22.3636L3.20724 21.6147Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8137 11.9423C27.7412 11.9423 26.1015 16.4269 24.6526 16.9984C23.2038 17.571 19.4344 17.6855 17.0002 17.6855",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4827 16.0003C27.4827 16.9312 28.2231 17.6846 29.1379 17.6846C30.0527 17.6846 30.7931 16.9312 30.7931 16.0003C30.7931 15.0695 30.0527 14.3161 29.1379 14.3161C28.2231 14.3161 27.4827 15.0695 27.4827 16.0003Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1201 12.7334C30.1201 12.2068 32.4483 11.6892 32.4483 11.2288C32.4483 10.7685 30.855 9.82529 30.1311 9.82529C29.2616 9.82529 28.7617 11.7914 28.7617 11.7914",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 10.9472C19.3484 10.9472 28.0115 11.4917 28.8237 11.9375",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M30.793 21.6147C30.793 21.6147 30.3042 22.5197 29.4137 23.1114C28.5233 23.7043 25.2758 23.8604 25.2758 23.8604L24.5862 22.3636L30.793 21.6147Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8278 22.1761H17.0002H12.1726L11.4829 23.8604H17.0002H22.5174L21.8278 22.1761Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.51759 16.0003C6.51759 16.9312 5.77718 17.6846 4.86242 17.6846C3.94766 17.6846 3.20724 16.9312 3.20724 16.0003C3.20724 15.0695 3.94766 14.3161 4.86242 14.3161C5.77718 14.3161 6.51759 15.0695 6.51759 16.0003Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84567 12.7949C3.84567 12.2683 1.55161 11.6889 1.55161 11.2286C1.55161 10.7682 3.14498 9.82506 3.86885 9.82506C4.73836 9.82506 5.17974 11.9315 5.17974 11.9315",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1351 26.2754C28.9202 26.3865 27.0543 26.5033 24.2471 26.5796C24.4491 27.278 25.0769 27.79 25.8273 27.79H30.2411C31.1558 27.79 31.8962 27.0366 31.8962 26.1058V25.4108C31.4427 25.8914 30.8281 26.2114 30.1351 26.2754Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M3.86514 26.2754C3.17217 26.2114 2.55755 25.8914 2.10403 25.4108V26.1058C2.10403 27.0366 2.84445 27.79 3.75921 27.79H8.173C8.92334 27.79 9.55121 27.278 9.75314 26.5796C6.94597 26.5033 5.08003 26.3865 3.86514 26.2754Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M17 4.21059C20.0863 4.21059 24.8257 4.38575 25.3476 4.91235C25.8695 5.43896 28.8257 11.93 28.8257 11.93C28.8257 11.93 31.6516 13.5525 32.3048 14.737C32.9559 15.9216 33 18.6411 33 20.3511C33 21.2303 32.8157 22.6888 32.637 23.8981C32.4483 25.1815 31.4154 26.1572 30.1354 26.2751C28.0819 26.4626 24.1967 26.667 17 26.667C9.80331 26.667 5.91697 26.4626 3.86455 26.2751C2.58455 26.1572 1.55172 25.1815 1.36304 23.8981C1.18428 22.6888 1 21.2303 1 20.3511C1 18.6411 1.04414 15.9216 1.69517 14.737C2.34841 13.5525 5.17434 11.93 5.17434 11.93C5.17434 11.93 8.13048 5.43896 8.65241 4.91235C9.17434 4.38575 13.9137 4.21059 17 4.21059Z",
    stroke: "#282827",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCarB);
export default __webpack_public_path__ + "static/media/icon-car-B.e042ff2131d654b3b7e86a298cfeb3c8.svg";
export { ForwardRef as ReactComponent };